'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/querystring-es3/index.js
// module id = 728
// module chunks = 0 1 2 3 4 5 6 7 8